// Putting logout because of no activity
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toastMessage } from "../utils/toastMessageHelper";
import { decryptData } from "utils/dataCipherHelper";

// this code is created an instance with base url for admin
// const url =
export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const masterInstace = axios.create({
  baseURL: process.env.REACT_APP_MASTER_URL,
});

// get token
export const getFromLocal = (key = "token", inKey = "cashsurvey_token") => {
  // Retrieve the 'cashsurvey_token' object from localStorage
  if (inKey) {
    let localData = JSON.parse(localStorage.getItem(inKey)) || {};

    if (key && key.includes(".")) {
      // Handle nested keys if the key contains a dot notation (e.g. parentKey.childKey)
      const [parentKey, childKey] = key.split(".");
      return localData[parentKey]?.[childKey] ?? null;
    }

    // For simple keys
    return localData[key] ?? null;
  } else {
    return localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : null;
  }
};

// Set Token to local storage (token,language)
export const setToLocal = (key, value, inKey = "cashsurvey_token") => {
  try {
    // Retrieve existing 'cashsurvey_token' object from localStorage or default to empty object
    if (inKey) {
      let localData = localStorage.getItem(inKey)
        ? JSON.parse(localStorage.getItem(inKey))
        : {};

      if (key.includes(".")) {
        // Handle nested keys if the key contains a dot notation (e.g. parentKey.childKey)
        const [parentKey, childKey] = key.split(".");

        // Ensure parentKey exists or create an empty object
        localData[parentKey] = localData[parentKey] || {};
        localData[parentKey][childKey] = value;
      } else {
        // For simple keys
        localData[key] = value;
      }
      localStorage.setItem(inKey, JSON.stringify(localData));
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }

    // Save the updated data back to localStorage
  } catch (error) {
    console.error("Error updating localStorage:", error);
  }
};

export const setHeaders = (type = "json") => {
  switch (type) {
    case "multipart":
      return {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "Accept-Language": getFromLocal("i18nLng", null) || "en",
        },
      };
    case "json":
    default:
      return {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Accept-Language": getFromLocal("i18nLng", null) || "en",
        },
      };
  }
};

export const removeToken = (key = "cashsurvey_token") => {
  localStorage.removeItem(key);
};

// this interceptors checks user's token is valid or not
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const resInterceptor = (response) => {
      const decryptedResponse = decryptData(response.data);
      if (decryptedResponse?.status === 401) {
        // deleteFcmToken();
        removeToken();
        navigate("/");
      }
      return response;
    };

    const errInterceptor = (error) => {
      const { response: { data } = {}, code } = error;
      const { message, status } = decryptData(data);

      if (status === 401) {
        removeToken();
        navigate("/");
      }

      // Handle network errors (e.g., server unreachable, connection refused)
      if (code === "ERR_NETWORK" || code === "ERR_CONNECTION_REFUSED") {
        toastMessage(
          "Connection error. Please check your network or server.",
          "error",
          "networkError"
        );
        return Promise.reject(error);
      }

      if (status !== 200) {
        toastMessage(message, "error", "errorMeesage");
      }

      return error.response;
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, []);

  return isSet && children;
};
